import React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle } from '../../../utils/utils';

/**
 * Ajoneuvot / Laitteet.
 *
 * The two lists read the same endpoint and differ only by the asset group they
 * request, but their columns diverge enough (hours and asset type against
 * plate, inspection date and Traficom sync) that a shared table would leave
 * most cells empty for one of them.
 */
class FleetVehicleSubNav extends React.Component {
  render() {
    const { t, organizationId, active } = this.props;

    const tabs = [
      { id: 'vehicles', label: t('subTabVehicles'), to: `/organization_garage/${organizationId}/vehicles/` },
      { id: 'equipment', label: t('subTabEquipment'), to: `/organization_garage/${organizationId}/equipment/` },
    ];

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            {tabs.map(tab => (
              <Link
                key={tab.id}
                to={tab.to}
                style={{
                  ...getStyle(screenSize, styles, 'tab'),
                  ...(active === tab.id ? getStyle(screenSize, styles, 'tabActive') : {}),
                }}
              >
                {tab.label}
              </Link>
            ))}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 8,
    },
    tab: {
      padding: '8px 24px',
      color: '#FFF',
      fontSize: 16,
      textDecoration: 'none',
      opacity: 0.6,
      borderBottom: '2px solid transparent',
    },
    tabActive: {
      opacity: 1,
      borderBottom: '2px solid #FFF',
    },
  },
  small: {
    tab: {
      padding: '8px 12px',
      fontSize: 14,
    },
  },
};

export default translate('VehicleListView')(FleetVehicleSubNav);
